export const PAGE_NAME = 'homepage_logged_out';

export const MIXPANEL_PAGE_NAME = 'Homepage';
export const BIGQUERY_PAGE_NAME = 'homepage';

export const BIGQUERY_REVAMP_PAGE_NAME = 'LOHP';
